import './src/main.css'
import BorderBox8 from './src/main.vue'

export default function (Vue) {
  Vue.component(BorderBox8.name, BorderBox8)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/borderBox8/index.js